import { render, staticRenderFns } from "./UpcomingEventsList.vue?vue&type=template&id=092f4a76&scoped=true&"
import script from "./UpcomingEventsList.vue?vue&type=script&lang=js&"
export * from "./UpcomingEventsList.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingEventsList.vue?vue&type=style&index=0&id=092f4a76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092f4a76",
  null
  
)

export default component.exports